import { Info } from "@phosphor-icons/react";

import { formatPrice } from "features/subscriptions/utils";

import Skeleton from "common/components/ui/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

export default function ToPayNow({
  amount,
  isLoading,
}: {
  amount: number;
  isLoading: boolean;
}) {
  return (
    <div className="flex items-center justify-between px-2.5">
      <div className="flex gap-x-0.5 items-center">
        <span className="text-md-bold">To pay now</span>
        <Tooltip>
          <TooltipTrigger>
            <Info weight="fill" className="text-black-300 size-4" />
          </TooltipTrigger>
          <TooltipContent>
            The price to immediately update your subscription. If you are making
            a change mid-billing cycle, this will be prorated based on your next
            renewal date. If no immediate payment is needed, it will be $0
          </TooltipContent>
        </Tooltip>
      </div>

      {isLoading ? (
        <Skeleton className="h-8 w-24" />
      ) : (
        <span className="text-2xl-bold text-purple-600">
          {formatPrice(amount)}
        </span>
      )}
    </div>
  );
}
